import React from 'react';

const Withholding: React.FC = () => {
  return null;
};

export default Withholding;
